import styled from '../../utils/styled';
import { mediaBreakpointUpMD } from '../../../constants/style-constants';

export const NavigationMenuContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
});

export const Backdrop = styled.div({
  position: 'fixed',
  backgroundColor: 'rgba(0, 0, 0, 0.8)',
  width: '100%',
  bottom: '0',
  top: '60px',
}, ({ open }) => ({
  display: open ? 'block' : 'none',
}));

export const MainContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  height: '60px',
});

export const NavBar = styled.div(({ alternate }) => ({
  display: 'flex',
  height: 'inherit',
  alignItems: 'center',
  justifyContent: 'flex-end',
  borderBottom: `1px solid ${alternate ? '#4ecef7' : '#343434'}`,

  [mediaBreakpointUpMD]: {
    padding: '0px 20px',
    borderBottom: 'none',
  },
}));

export const AccessibilityLink = styled.a({
  whiteSpace: 'nowrap',
  background: '#fff',
  border: '1px solid #ccc',
  lineHeight: '2em',
  zIndex: '1',
  display: 'block',
  color: '#333',
  position: 'absolute',
  width: '200px',
  textAlign: 'center',
  padding: '10px',
  opacity: '0',
  transform: 'translateY(-200%)',

  '&:focus': {
    opacity: '1',
    transform: 'translateY(0%)',
  },
});
